export async function checkTrailer(selectedValue) {
  const warningPlaceholder = document.getElementById("warning-placeholder");
  warningPlaceholder.textContent = "";
  warningPlaceholder.classList.add("hidden");
  if (!selectedValue) return;

  try {
    const url = `/api/orders/trips/local/${warningPlaceholder.dataset.pk}/trailer/${selectedValue}/`;
    const response = await fetch(url);

    if (response.status === 200) {
      const data = await response.json();
      warningPlaceholder.textContent = data.message;
      warningPlaceholder.classList.remove("hidden");
    }
  } catch (error) {
    console.error("Error fetching warning:", error);
  }
}

export async function initializeCheckTrailer() {
  const trailerField = document.querySelector("#id_trailer-trailer");
  if (trailerField) {
    trailerField.addEventListener("change", async function (event) {
      const selectedValue = event.detail.value;
      await checkTrailer(selectedValue);
    });
    const trailerChoices = bundle.choices.getChoicesInstance(
      document.querySelector("#id_trailer-trailer"),
    );
    if (
      trailerChoices.getValue().value &&
      trailerChoices.getValue().value !== ""
    ) {
      await checkTrailer(trailerChoices.getValue().value);
    }
  }
}

export default {
  initializeCheckTrailer,
};
